import { Config as Selected } from './Config-lwwp';

const Config = Selected;

export { Config }
